import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
//components
import Modal from "../../../components/modal/Modal";
import Select from "../../../components/input/Select";
import ModalClientData from "../../../components/payment/ModalClientData";
import ModalPixPayment from "../../../components/payment/ModalPixPayment";
import UserPaymentMethods from "../../../components/payment/UserPaymentMethods";
//context
import { useUserRegistrationContext } from "../UserRegistrationContext";
//utils
import { formatCurrency } from "../../../utils/formatCurrency";
//services
import { getUserCreditCard } from "../../../services/ClientArea/getUserCreditCard";
import { queryClient } from "../../../utils/queryClient";

const ModalOpenPayments = ({ visible, setVisible }) => {
  const [disabledButton, setDisabledButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const {
    form,
    cards,
    setCards,
    cardState,
    pixClient,
    pixDataQR,
    setPixDataQR,
    handleSubmit,
    baseDataForm,
    itemsSelected,
    paymentMethod,
    loadingButton,
    activeIndexModal,
    handleInputFocus,
    setPaymentMethod,
    creditCardClient,
    visiblePixPayment,
    handleInputChange,
    optionsInstallments,
    setActiveIndexModal,
    setCreditCardClient,
    setVisiblePixPayment,
    visiblePaymentMethods,
    setOptionsInstallments,
    visibleModalCreditCard,
    setVisiblePaymentMethods,
    setVisibleModalCreditCard,
  } = useUserRegistrationContext();

  const handleSelectPaymentMethod = (value) => {
    const updatedData = [...cards];
    const indexActive = updatedData.findIndex((c) => c.active === 1);
    if (indexActive !== -1) {
      updatedData[indexActive].active = 0;
    }
    setCards(updatedData);
    if (value === "card") {
      setVisiblePaymentMethods(false);
    }
    setPaymentMethod(value);
  };

  const handleSelectCard = async (card) => {
    // console.log(card);
    const updatedData = [...cards];
    const index = updatedData.findIndex((c) => c.id === card.id);
    const indexActive = updatedData.findIndex((c) => c.active === 1);
    if (indexActive !== -1) {
      updatedData[indexActive].active = 0;
    }
    if (index !== -1) {
      updatedData[index].active = 1;
    }
    setCards(updatedData);
    setPaymentMethod(null);
  };

  useEffect(() => {
    const testDisabledButton = () => {
      const isCardStateEmpty = Object.values(cardState).some(
        (value) => value === ""
      );

      if (paymentMethod === "pix") {
        setDisabledButton(false);
        return;
      }

      if (
        (isCardStateEmpty || paymentMethod === null) &&
        cards.every((card) => card.active === 0)
      ) {
        setDisabledButton(true);
      } else {
        setDisabledButton(false);
      }
    };
    testDisabledButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardState, pixClient, paymentMethod, cards]);

  useEffect(() => {
    const fetchCards = async () => {
      setIsLoading(true);
      try {
        const data = await getUserCreditCard();
        setIsLoading(false);
        setCards(data);
      } catch (error) {
        toast.error("Houve um erro ao buscar os cartões cadastrados");
      }
    };
    fetchCards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const newOptions = [];
  
    const maxInstallments = Math.max(
      ...itemsSelected.map((item) => item.installments_late_payment || 1)
    );
  
    const totalValue = itemsSelected?.reduce(
      (total, payment) => total + (payment.overdue ? parseFloat(payment.total_due) : payment.value),
      0
    );
  
    for (let i = 1; i <= maxInstallments; i++) {
      newOptions.push({
        label: `${i} X de ${formatCurrency((totalValue / i).toFixed(2))}`,
        value: i,
      });
    }
  
    setOptionsInstallments(newOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemsSelected]);

  return (
    <>
      <Modal
        visible={visible}
        onHide={() => setVisible(false)}
        dynamicTitle="Selecione a forma de pagamento"
        footer={
          visiblePaymentMethods && (
            <div className="d-flex justify-content-center">
              <Button
                label="Realizar Pagamento"
                className="rounded-pill"
                icon="fa-solid fa-check"
                loading={loadingButton}
                disabled={disabledButton}
                onClick={() => handleSubmit()}
              />
            </div>
          )
        }
      >
        {isLoading ? (
          <Skeleton width="100%" height="400px" />
        ) : (
          <>
            {visiblePaymentMethods && (
              <>
                <div className="row text-center justify-content-center">
                  <div className="mb-2">
                    <h3 className="fw-bolder">Total a Pagar</h3>
                    <h2 className="fw-bolder">
                      {formatCurrency(
                        itemsSelected?.reduce(
                          (total, payment) => total + (payment.overdue ? parseFloat(payment.total_due) : payment.value),
                          0
                        )
                      )}
                    </h2>
                  </div>
                  <h4 className="">
                    Selecione uma forma de pagamento abaixo para realizar o
                    pagamento da parcela
                  </h4>
                </div>
              </>
            )}
            <UserPaymentMethods
              pix
              card
              cards={cards}
              form={form}
              cardState={cardState}
              paymentMethod={paymentMethod}
              setPaymentMethod={setPaymentMethod}
              handleSelectCard={handleSelectCard}
              handleInputFocus={handleInputFocus}
              creditCardClient={creditCardClient}
              handleInputChange={handleInputChange}
              setActiveIndexModal={setActiveIndexModal}
              visiblePaymentMethods={visiblePaymentMethods}
              setVisiblePaymentMethods={setVisiblePaymentMethods}
              setVisibleModalCreditCard={setVisibleModalCreditCard}
              handleSelectPaymentMethod={handleSelectPaymentMethod}
            />

            {paymentMethod === "card" ||
            cards?.some((card) => card.active === 1) ? (
              <>
                <h4 className="mb-0">Defina quantas prestações</h4>
                <Select
                  name="installments"
                  label="Número de prestações"
                  control={form.control}
                  options={optionsInstallments}
                  errors={form.formState.errors}
                />
              </>
            ) : null}
          </>
        )}
      </Modal>

      <ModalClientData
        noData
        baseDataForm={baseDataForm}
        activeIndex={activeIndexModal}
        visible={visibleModalCreditCard}
        creditCardClient={creditCardClient}
        setActiveIndex={setActiveIndexModal}
        setVisible={setVisibleModalCreditCard}
        setCreditCardClient={setCreditCardClient}
      />

      <ModalPixPayment
        pixDataQR={pixDataQR}
        setPixDataQR={setPixDataQR}
        visible={visiblePixPayment}
        setVisible={setVisiblePixPayment}
        onContinue={() => {
          queryClient.invalidateQueries("UserOpenPayments");
          setVisiblePixPayment(false);
          setVisible(false);
        }}
      />
    </>
  );
};

export default ModalOpenPayments;
